<template>
    <div id="svgBox">
        <div id="svgTop">
            <div style="margin: 5px 0">
                <tr>
                    <td style="width:50px">{{$t('getapi[7175]')}}</td>
                    <td style="width:250px">
                        <el-radio-group v-model="scale" size="mini" @change="wekk">
                            <el-radio-button :label="$t('getapi[7176]')"></el-radio-button>
                            <el-radio-button :label="$t('getapi[7177]')"></el-radio-button>
                            <el-radio-button :label="$t('getapi[7178]')"></el-radio-button>
                        </el-radio-group>
                    </td>
                    <td style="width:50px">{{$t('getapi[7179]')}}</td>
                    <td style="width:150px">
                        <el-date-picker v-model="startDate" type="date" size="mini"></el-date-picker>
                    </td>
                    <td style="width:50px">{{$t('getapi[3327]')}}</td>
                    <td style="width:150px">
                        <el-date-picker v-model="endDate" type="date" size="mini"></el-date-picker>
                    </td>
                    <td style="width:50px">{{$t('getapi[4285]')}}</td>
                    <td style="width:150px">
                        <el-input size="small" v-model="socode"></el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[6341]')}}</td>
                    <td style="width:150px">
                        <el-input size="small" v-model="rcode"></el-input>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="update">{{$t('getapi[507]')}}</el-button>
                    </td>
                </tr>
            </div>
            <div style="margin-top: 5px">
                <div ref="gantt" id="gant"></div>
            </div>
        </div>
        <div id="svgResize"></div>
        <div id="svgDown" style="border-top: 1px solid #b5b9a9; ">
            <div class="tips">
                <a class="change" @click="openorclose(0)" v-if="tipsType == 1">{{$t('getapi[7180]')}}</a>
                <a class="change" @click="openorclose(1)" v-if="tipsType == 0">{{$t('getapi[934]')}}</a>
            </div>
            <div>
                <ul class="Boxs" ref="Box">
                    <li class="left1" ref="left1">
                        <div style="margin-top: 10px;text-align: center">
                            <span style="font-size: 25px">{{$t('getapi[7181]')}}</span>
                        </div>
                        <el-divider></el-divider>
                        <el-table
                                id="xpane-0"
                                :data="dataResource"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column show-overflow-tooltip prop="key" :label="$t('getapi[1479]')">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="value" :label="$t('getapi[3192]')">
                            </el-table-column>
                        </el-table>
                    </li>
                    <li class="resize" ref="resize">
                        <i class="el-icon-caret-right"></i>
                        <i class="el-icon-caret-left"></i>
                    </li>
                    <li class="mid1" ref="mid1">
                        <el-table
                                id="xpane-1"
                                :data="dataResourceDetail"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                :height="resourcedetailheight"
                                :row-class-name="tableRowClassName"
                                size="mini"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"
                                             width="150">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="cut_no" :label="$t('getapi[8188]')"
                                             width="60">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')"
                                             align="right" width="80">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="start_time" :label="$t('getapi[6339]')"
                                             width="150">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="end_time" :label="$t('getapi[4057]')"
                                             width="150">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="gongshi" :label="$t('getapi[7182]')"
                                             align="right" width="80">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="plan_finish_qty" :label="$t('getapi[4516]')"
                                             align="right" width="80">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="finish_qty" :label="$t('getapi[4883]')"
                                             align="right" width="80">
                            </el-table-column>
                            <el-table-column prop="r_name" :label="$t('getapi[552]')" width="80">
                                <template scope="scope">
                                    {{expStatus(scope.row)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import {Loading} from 'element-ui';
    import {gantt} from 'dhtmlx-gantt'

    export default {
        name: '2_apsnew',
        component: {gantt},
        /*props: {
            tasks: {
                type: Object,
                default () {
                    return {
                        data: [],
                        links:[]
                    }
                }
            }
        },*/
        data() {
            return {
                zoomConfig: {
                    minColumnWidth: 8,
                    maxColumnWidth: 50,
                    levels: [
                        [{
                            unit: "month",
                            step: 1,
                            format: "%Y %M"
                        },
                            {
                                unit: "day",
                                format: "%d",
                                step: 1
                            },
                        ],
                        [{
                            unit: "day",
                            step: 1,
                            format: "%Y %M %d %l"
                        },
                            {
                                unit: "hour",
                                step: 1,
                                format: "%G"
                            },
                        ],
                        [{
                            unit: "day",
                            step: 1,
                            format: "%Y %M %d %l"
                        },
                            {
                                unit: "hour",
                                step: 1,
                                format: "%G"
                            },
                            {
                                unit: "minute",
                                format: this.monRangeFormat(15),
                                step: 15
                            }
                        ]
                    ],
                    startDate: new Date(this.getMonth()[0]),
                    endDate: new Date(this.getMonth()[1]),
                    useKey: "ctrlKey",
                    trigger: "wheel",
                    element: function () {
                        return gantt.$root.querySelector(".gantt_task");
                    },
                },
                scale: '按天',
                startDate: '',
                endDate: '',
                socode: '',
                rcode: '',
                dataResource: [],
                dataResourceDetail: [],
                tipsType: 1, // 1:打开详情2：隐藏
                resourcedetailheight: '',
                tasks: {
                    data: [],
                    links: [],
                },
            };
        },
        create() {
        },
        beforeMount() {
            let that = this;
        },
        watch: {
            dataResource: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            dataResourceDetail: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(1)
                })
            },
        },
        mounted() {
            let that = this;
            that.resourcedetailheight = '10px'
            that.$limits.dragControllerDiv1();
            that.dragControllerDivPortrait();
            that.getSetting()
            gantt.attachEvent("onTaskClick", function (id, e) {
                if(id < 10000){
                    return false
                }
                let task = gantt.getTask(id)
                that.getDetail(task.text)
                that.getDetailData(task.text)
            });
            /*$('.gantt_layout_cell_border_right').on('dblclick',function(){
                gantt.config.details_on_dblclick = false
            })*/
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (row.exception_flag == 1) {
                    return 'red';
                }
            },
            // 获取初始值
            getSetting() {
                let that = this
                // 获取当前月的第一天
                let start = new Date();
                start.setDate(1);
                // 获取当前月的最后一天
                let date = new Date();
                let currentMonth = date.getMonth();
                let nextMonth = ++currentMonth;
                let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                let oneDay = 1000 * 60 * 60 * 24;
                let end = new Date(nextMonthFirstDay - oneDay);
                that.startDate = that.transferDate(start); // 日期变换
                that.endDate = that.transferDate(end); // 日期变换
                gantt.i18n.setLocale('cn') // 国际化
                gantt.config.xml_date = "%Y-%m-%d %H:%i";
                gantt.config.min_column_width = 20; //设置时间线区域中列的最小宽度
                gantt.config.duration_unit = "minute"; //拖动持续时间单位
                gantt.config.duration_step = 1
                gantt.setWorkTime({
                    hours: ["0:00-23:59"]
                }); //global working hours
                gantt.setWorkTime({
                    day: 6,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 0,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 1,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 2,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 3,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 4,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 5,
                    hours: true
                });
                gantt.config.scales = [{
                    unit: "month",
                    step: 1,
                    format: "%Y %M"
                },
                    {
                        unit: "day",
                        step: 1,
                        format: "%d"
                    },
                ];
                gantt.templates.timeline_cell_class = function (item, date) {
                    if (date.getDay() == 0 || date.getDay() == 6) {
                        return 'weekend';
                    }
                };
                gantt.config.details_on_dblclick = true
                /*gantt.config.scale_height = 45; //设置时间刻度的高度和网格的标题
                gantt.config.row_height = 45;   //进度条容器高
                gantt.config.grid_width = 500;  //左侧宽*/
               /* gantt.config.autofit = true;  //左侧是否自适应
                gantt.config.touch = "force"; //开启触屏模式
                /!*gantt.config.autoscroll = true;*!/
                gantt.config.details_on_dblclick = true;  // 开启双击表格启动弹出窗
                /!*gantt.config.autosize = 'x';*!/  // y轴自适应高度
                gantt.config.drag_links = false;  //取消连线
                gantt.config.drag_progress = false; // 取消进度条
                gantt.config.readonly = false;  //只读
                //gantt.config.fit_tasks = true;  //自动调整图表坐标轴区间用于适配task的长度
                gantt.config.wide_form = false; //  弹窗宽
                gantt.config.auto_scheduling = true;
                gantt.config.auto_scheduling_compatibility = true;
                gantt.config.fit_tasks = true;*/
                gantt.plugins({ // 提示信息
                    tooltip: true// 启用 tooltip 插件
                })
                gantt.attachEvent('onTaskDblClick', function (id, e) {
                    //点击左侧任务列表不弹窗
                    if(e.target.getAttribute('class') == 'gantt_tree_content'){
                        return false
                    }
                    return true;
                });

                gantt.serverList("priority", [{
                    key: 1,
                    label: "锁定",
                    backgroundColor: "#ff0000",
                    textColor: "#FFF"
                },
                    {
                        key: 2,
                        label: "正常",
                        backgroundColor: "#03A9F4",
                        textColor: "#FFF"
                    },
                    {
                        key: 3,
                        label: "已完工",
                        backgroundColor: "#55aa00",
                        textColor: "#FFF"
                    },
                    {
                        key: 4,
                        label: "进行中",
                        backgroundColor: "#aaff00",
                        textColor: "#FFF"
                    },
                    {
                        key: 5,
                        label: "异常",
                        backgroundColor: "#ff7879",
                        textColor: "#FFF"
                    }
                ]);
                gantt.locale.labels.column_so_code = gantt.locale.labels.section_so_code = "工单号";
                gantt.locale.labels.column_cut_no = gantt.locale.labels.section_cut_no = "切分号";
                gantt.locale.labels.column_routing_sequence_no = gantt.locale.labels.section_routing_sequence_no = "工序号";
                gantt.locale.labels.column_start_time = gantt.locale.labels.section_start_time = "开始时间";
                gantt.locale.labels.column_end_time = gantt.locale.labels.section_end_time = "结束时间";
                gantt.locale.labels.column_gongshi = gantt.locale.labels.section_gongshi = "工期（分钟）";
                gantt.locale.labels.column_plan_finish_qty = gantt.locale.labels.section_plan_finish_qty = "计划数";
                gantt.locale.labels.column_finish_qty = gantt.locale.labels.section_finish_qty = "完工数";
                gantt.locale.labels.column_r_name = gantt.locale.labels.section_r_name = "状态";
                gantt.config.lightbox.sections = [{
                    name: "so_code",
                    height: 30,
                    map_to: "so_code",
                    type: "textarea",
                    focus: true,
                },
                    {
                        name: "cut_no",
                        height: 30,
                        map_to: "cut_no",
                        type: "textarea",
                    },
                    {
                        name: "routing_sequence_no",
                        height: 30,
                        map_to: "routing_sequence_no",
                        type: "textarea",
                    },
                    {
                        name: "start_time",
                        height: 30,
                        type: "textarea",
                        map_to: "sdate",
                    },
                    {
                        name: "end_time",
                        height: 30,
                        type: "textarea",
                        map_to: "edate",
                        readonly: true
                    },
                    {
                        name: "gongshi",
                        height: 30,
                        map_to: "duration",
                        type: "textarea",
                    },
                    {
                        name: "plan_finish_qty",
                        height: 30,
                        map_to: "plan_finish_qty",
                        type: "textarea",
                    },
                    {
                        name: "finish_qty",
                        height: 30,
                        map_to: "finish_qty",
                        type: "textarea",
                    },
                    {
                        name: "r_name",
                        height: 30,
                        map_to: "r_name",
                        type: "textarea",
                        readonly: true,
                    },
                ];
                gantt.attachEvent("onParse", function () {
                    var styleId = "dynamicGanttStyles";
                    var element = document.getElementById(styleId);
                    if (!element) {
                        element = document.createElement("style");
                        element.id = styleId;
                        document.querySelector("head").appendChild(element);
                    }
                    var html = [];
                    var resources = gantt.serverList("priority");
                    console.log('resource' + JSON.stringify(resources))
                    resources.forEach(function (r) {
                        html.push(".gantt_task_line.gantt_resource_" + r.key + "{" +
                            "background-color:" + r.backgroundColor + "; " +
                            "color:" + r.textColor + ";" +
                            "}");
                    });
                    element.innerHTML = html.join("");
                });
                gantt.templates.grid_row_class =
                    gantt.templates.task_row_class =
                        gantt.templates.task_class = function (start, end, task) {
                            var css = [];
                            if (task.$virtual || task.type == gantt.config.types.project)
                                css.push("summary-bar");

                            if (task.priority) {
                                css.push("gantt_resource_task gantt_resource_" + task.priority);
                            }
                            return css.join("");
                        };
                //左侧显示列名
                gantt.config.columns = [
                    {name: "text", label: "资源名", align: "center", width: 90,},
                    {name: "start_date", label: "开始时间", align: "center", width: 90,},
                    {name: "duration", label: "工时(分)", align: "center", width: 60,},
                    {
                        name: "progress", label: "完成率", align: "center", width: 60,
                        template: function (item) {
                            if (item.progress >= 1)
                                return '<span style="display:inline-block;width:100%">100%</span>';
                            if (item.progress == 0)
                                return '<span style="display:inline-block;width:100%">0%</span>';
                            return '<span style="display:inline-block;width:100%">' + Math.round(item
                                .progress * 100) + '%</span>';
                        }
                    },
                ];
                gantt.config.tooltip_hide_timeout = 2000;
                gantt.init(this.$refs.gantt, new Date(this.getMonth()[0]), new Date(this.getMonth()[1]));
                gantt.parse(that.tasks);
            },
            changeScales(e) {
                if (e == 0) {
                    gantt.config.scales = [{
                        unit: "day",
                        step: 1,
                        format: "%Y %M %d %l"
                    },
                        {
                            unit: "hour",
                            step: 1,
                            format: "%G"
                        },
                    ];
                }
                if (e == 1) {
                    gantt.config.scales = [{
                        unit: "month",
                        step: 1,
                        format: "%Y %M"
                    },
                        {
                            unit: "day",
                            step: 1,
                            format: "%d"
                        },
                    ];
                }
                if (e == 2) {
                    gantt.config.scales = [{
                        unit: "day",
                        step: 1,
                        format: "%Y %M %d 日 %l"
                    },
                        {
                            unit: "hour",
                            step: 1,
                            format: "%G"
                        },
                        {
                            unit: "minute",
                            format: this.monRangeFormat(15),
                            step: 15
                        }
                    ];
                }
                gantt.render();
            },
            monRangeFormat(step) {
                let monToStr = gantt.date.date_to_str("%i")
                return function (date) {
                    var intervalEnd = new Date(gantt.date.add(date, step, "minute") - 1)
                    //return monToStr(date) + " - " + monToStr(intervalEnd);
                    return monToStr(intervalEnd);
                };
            },
            getMonth(Fn) {
                let that = this
                // 获取当前月的第一天
                let start = new Date();
                start.setDate(1);
                // 获取当前月的最后一天
                let date = new Date();
                let currentMonth = date.getMonth();
                let nextMonth = ++currentMonth;
                let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                let oneDay = 1000 * 60 * 60 * 24;
                let end = new Date(nextMonthFirstDay - oneDay);
                let startDate = that.transferDate(start); // 日期变换
                let endDate = that.transferDate(end); // 日期变换
                let times = [];
                times.push(startDate);
                times.push(endDate);
                return times;
            },
            transferDate(date) {
                // 年
                let year = date.getFullYear();
                // 月
                let month = date.getMonth() + 1;
                // 日
                let day = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                let dateString = year + '-' + month + '-' + day;
                return dateString;
            },
            //刻度切换
            // 刻度切换
            wekk(e) {
                let that = this
                if (e == '按小时') {
                    that.changeScales(0);
                }
                if (e == '按天') {
                    that.changeScales(1);
                }
                if (e == '按分钟') {
                    that.changeScales(2);
                }
            },
            update() {
                let that = this
                gantt.clearAll()
                that.tasks.data = []
                let parm = {
                    so_code: that.so_code,
                    r_code: that.rcode,
                    s_date: that.startDate,
                    e_date: that.endDate,
                    flg: 0
                }
                that.$http.urlpost('/Pro/Aps/APSList', parm, function (res) {
                    if (res.Success == 1) {
                        let data = []
                        let arr = res.DataContent.Lines
                        for (let i = 0; i < arr.length; i++) {
                            let ff = (arr[i].finish_qty / arr[i].plan_finish_qty).toFixed(2);
                            let lock = arr[i].lock_schedule;
                            let finish_flag = arr[i].finish_flag;
                            let s_flag = arr[i].s_flag;
                            let pro = 0;
                            let rname = ''
                            if(arr[i].exception_flag == 1){
                                pro = 5;
                                rname = '异常'
                            } else {
                                if (finish_flag == 1) {
                                    pro = 3;
                                    rname = '已完工'
                                } else {
                                    if (lock == 0) {
                                        if (s_flag == 1) {
                                            pro = 4;
                                            rname = '进行中'
                                        } else {
                                            pro = 2;
                                            rname = '正常';
                                        }

                                    } else {
                                        pro = 1;
                                        rname = '锁定'
                                    }
                                }
                            }
                            data = [...data, {
                                id: i + 2,
                                r_code: arr[i].r_code,
                                text: arr[i].r_code,
                                start_date: arr[i].start_time,
                                end_date: arr[i].end_time,
                                duration: arr[i].gongshi,
                                progress: ff,
                                parent: 1,
                                render: 'split',
                                open: true,
                                users: arr[i].r_code,
                                so_code: arr[i].so_code,
                                routing_sequence_no: arr[i].routing_sequence_no,
                                priority: pro,
                                plan_finish_qty:arr[i].plan_finish_qty,
                                finish_qty:arr[i].finish_qty,
                                r_name: rname,
                                sdate: arr[i].start_time,
                                edate: arr[i].end_time
                            }]
                        }
                        let parm1 = {
                            so_code: that.so_code,
                            r_code: that.rcode,
                            s_date: that.startDate,
                            e_date: that.endDate,
                            flg: 1
                        }
                        that.$http.urlpost('/Pro/Aps/APSList', parm1, function (res1) {
                            if (res1.Success == 1) {
                                let item = res1.DataContent.Lines
                                if (item.length > 0) {
                                    let jsons = []
                                    for (let i = 0; i < item.length; i++) {
                                        jsons = [...jsons, {
                                            id: i + 10000,
                                            r_code: item[i].r_code,
                                            text: item[i].r_code,
                                            start_date: item[i].start_time,
                                            duration: item[i].gongshi == 0,
                                            progress: item[i].rate,
                                            users: item[i].r_code,
                                            priority: 2,
                                            render: 'split',
                                        }]
                                    }
                                    let jsondata = []
                                    for (let i = 0; i < jsons.length; i++) {
                                        jsondata.push(jsons[i])
                                        for (let j = 0; j < data.length; j++) {
                                            if (data[j].r_code == jsons[i].r_code) {
                                                data[j].parent = jsons[i].id;
                                                data[j].text = data[j].so_code + "-" + data[j]
                                                    .routing_sequence_no;
                                                data[j].render = "";
                                                data[j].open = true;
                                                jsondata.push(data[j]);
                                            }
                                        }
                                    }
                                    // 排序，后续优化接口排好传递过来
                                    /*let compare = function(obj1,obj2){
                                        let val1 = obj1.r_code;
                                        let val2 = obj2.r_code;
                                        if(val1 < val2){
                                            return -1;
                                        }else if(val1 > val2){
                                            return 1;
                                        }else{
                                            return 0;
                                        }
                                    }
                                    jsondata.sort(compare);*/
                                    gantt.config.start_date = new Date(that.startDate);
                                    gantt.config.end_date = new Date(that.endDate);
                                    gantt.init(that.$refs.gantt);
                                    console.log(jsondata)
                                    that.tasks.data = jsondata
                                    that.tasks.links = [];
                                    gantt.parse(that.tasks)
                                }
                            }
                        });
                    }
                });
            },
            getDetail(val) {
                let that = this
                console.log(val)
                that.dataResource = []
                let parm = {
                    r_code: val
                }
                that.$http.urlpost('/Pro/Aps/APSResourceListByCode', parm, function (res) {
                    if (res.Success == 1) {
                        if (res.DataContent.Lines.length > 0) {
                            let data = res.DataContent.Lines[0]
                            if (data)
                                that.dataResource.push({
                                    key: '资源号',
                                    value: data.r_code
                                })
                            that.dataResource.push({
                                key: '资源名',
                                value: data.r_name
                            })
                            that.dataResource.push({
                                key: '空闲阈值',
                                value: data.free_threshold
                            })
                            that.dataResource.push({
                                key: '工作日历',
                                value: data.work_calendar_code
                            })
                            that.dataResource.push({
                                key: '工作中心编码',
                                value: data.workcenter_code
                            })
                        }
                    }
                });
            },
            getDetailData(val) {
                let that = this
                let parm = {
                    so_code: '',
                    r_code: val,
                    s_date: that.startDate,
                    e_date: that.endDate,
                    flg: 0
                }
                that.$http.urlpost('/Pro/Aps/APSList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataResourceDetail = res.DataContent.Lines
                        that.openorclose(0)
                    }
                });
            },
            // 解析状态
            expStatus(row) {
                let that = this
                let lock = row.lock_schedule;
                let finish_flag = row.finish_flag;
                let s_flag = row.s_flag;
                let pro = '正常';
                if(row.exception_flag == 1){
                    pro = '异常';
                } else {
                    if (finish_flag == 1) {
                        pro = '已完工';
                    } else {
                        if (lock == 0) {
                            if (s_flag == 1) {
                                pro = '进行中';
                            } else {
                                pro = '正常';
                            }

                        } else {
                            pro = '锁定';
                        }
                    }
                }
                return pro;
            },
            openorclose(val) {
                let that = this
                that.tipsType = val
                var svgTop = document.getElementById("svgTop");
                var svgDown = document.getElementById("svgDown");
                var svgBox = document.getElementById("svgBox");
                var wheight = window.innerHeight
                if (val == 0) {
                    svgTop.style.height = wheight * 0.65 - 45 + 'px'
                    svgDown.style.height = wheight * 0.35 + 'px'
                    that.resourcedetailheight = wheight * 0.35 - 65
                    document.getElementById('gant').style.height = wheight * 0.65 - 90 + 'px'
                } else {
                    svgTop.style.height = wheight * 0.9 - 45 + 'px'
                    svgDown.style.height = wheight * 0.1 + 'px'
                    document.getElementById('gant').style.height = wheight * 0.9 - 90 + 'px'
                }
            },
            // 上下拖动
            dragControllerDivPortrait() {
                let that = this
                var svgResize = document.getElementById("svgResize");
                var svgTop = document.getElementById("svgTop");
                var svgDown = document.getElementById("svgDown");
                var svgBox = document.getElementById("svgBox");
                svgResize.onmousedown = function (e) {
                    var startY = e.clientY;
                    svgResize.top = svgResize.offsetTop;
                    document.onmousemove = function (e) {
                        var endY = e.clientY;
                        var moveLen = svgResize.top + (endY - startY);
                        var maxT = svgBox.clientHeight - svgResize.offsetHeight;
                        if (moveLen < 30) moveLen = 30;
                        if (moveLen > maxT - 30) moveLen = maxT - 30;
                        svgResize.style.top = moveLen;
                        svgTop.style.height = moveLen + "px";
                        svgDown.style.height = (svgBox.clientHeight - moveLen - 5) + "px";
                        that.resourcedetailheight = (svgBox.clientHeight - moveLen - 15)
                        document.getElementById('gant').style.height = moveLen - 50 + 'px'
                    }
                    document.onmouseup = function (evt) {
                        document.onmousemove = null;
                        document.onmouseup = null;
                        svgResize.releaseCapture && svgResize.releaseCapture();
                    }
                    svgResize.setCapture && svgResize.setCapture();
                    return false;
                }
            }
        }
    };
</script>

<style scoped lang="less">
    #gant{
        height:calc(100vh - 170px);
    }
    .tips {
        border-bottom: 1px solid #cdbdbd;
        line-height: 50px;
        padding-left: 20px;
    }

    .change {
        position: absolute;
        color: #03A9F4;
        margin-top: -50px;
        right: 30px;
        text-shadow: 0 0 10px #fff;
        font-weight: bold;
        cursor: pointer;
    }

    ul.Boxs {
        display: flex;
        li {
            list-style: none;
            display: block;
            margin: 0;
            padding: 0;
        }
        .left1 {
            width: calc(20% - 15px);
            height: 100%;
            float: left;
        }
        .resize {
            width: 13px;
            height: 100%;
            cursor: w-resize;
            float: left;
            background-size: 20px;
            position: relative;
            text-align: center;
            align-items: center;
            display: block;
            i {
                font-size: small;
                color: #fff;
                cursor: pointer;
                line-height: 3.5rem;
                height: 40%;
                display: inline-block;
                margin-top: 0.6rem;
            }
        }
        .mid1 {
            float: left;
            width: 80%;
            padding: 0;
            height: 100%;
            overflow: auto;
            background-color: #ffffff;
            z-index: 1
        }
        /deep/ .red {
            background: #ff7879;
        }
    }
</style>
